/***
*
*   APP LAYOUT
*   Main application layout containing the navigation
*   and header (title, secondary nav and signed in user)
*
*   PROPS
*   title: title of the view
*
**********/

import { useState, useEffect, Fragment, useContext } from 'react';
import { AuthContext, AppNav, Header, User, Icon, Card, useTranslation, useCan } from 'components/lib';
import Style from './app.module.scss';

export const navigateItems = (context, t, permissions) => {

  // to change the link to where this takes, update home_url in db
  let accountAddons = [];
  if (context?.user?.addons) {
    accountAddons = Object.keys(context?.user?.addons)?.map((addon) => {
      const currentAddon = context?.user?.addons[addon]

      // Only allow 'diy quiz' addon if the user has 'owner' permission
      if (currentAddon.id === 'diy-quiz' && !permissions?.diy) {
        return null; // Skip this addon
      }

      return {
        label: t(`nav.${currentAddon.id}`),
        icon: currentAddon.icon,
        link: currentAddon.link,
        showWarning: !currentAddon.enabled
      }
    }).filter(Boolean);
  }


  return [
    //TODO Need to Remove this code block on LMS plans phase out
    (permissions?.navigate && !context.user.lms_only) ? 
      { label: t('nav.home'), icon: 'home', link: '/navigate' } :
      null,
    ((permissions?.dashboard && context.user.lms_only)) 
      ? null : { label: t('nav.dashboard'), icon: 'pie-chart', link: '/dashboard' },

    ...(accountAddons?.length ? accountAddons : []),
    (context.user.accounts[0].enable_hiring && permissions?.hiring) 
      ? { label: t('nav.jobs'), icon: 'briefcase', link: '/hiring/jobs', style: { color: "black" } }
      : null,
    (permissions?.achievements && !context.user.lms_only) 
      ? { label: t('nav.achievements'), icon: 'award', link: '/achievements' }
      : null,
    (context?.user?.accounts[0]?.whitelabel)
      ? { label: t('nav.powered'), icon: 'zap', link: `https://www.topgrep.com/`, style: { color: "darkgrey" } }
      : null,
  ].filter(item => item !== null);
}

export function AppLayout({ mobile = false, ...props }) {

  const context = useContext(AuthContext);
  const permissions = {
    navigate: useCan('navigate.view'),
    dashboard: useCan('dashboard.view'),
    hiring: useCan('hiring.jobs.view'),
    achievements: useCan('achievements.view'),
    diy : useCan('addon.diyquiz.assign')
  };

  const [isMobile, setIsMobile] = useState(!mobile ? window.innerWidth <= 640 : false);
  const { t } = useTranslation();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(!mobile ? window.innerWidth <= 640 : false);
    };
    window.addEventListener('resize', handleResize);
    // return () => {
    //   window.removeEventListener('resize', handleResize);
    // };
  }, [mobile]);

  const ChildrenJSX = props.children


  return (
    <Fragment>
      {isMobile ?
        <><div className={Style.warnContainer}>
          <Card tittle="Oops! Your screen size is too small for this website." center shadow className={Style.warnCard}>
            <Icon
              className={Style.icon}
              size={30}
              color={'orange'}
              image={'alert-triangle'}
            />
            <p>Your screen size is too small for this website.</p>
          </Card>
        </div>
        </>
        : <></>}
      <div style={{ display: isMobile ? 'none' : '' }}>
        <AppNav
          items={navigateItems(context, t, permissions)}
        />
        <main className={Style.app}>

          <Header sideBarItems={navigateItems(context, t, permissions)} title={t(props.title) || props.title}>
            <User />
          </Header>

          <ChildrenJSX t={t} />

        </main>
      </div >
    </Fragment>
  );
}